import { Component, OnInit, OnChanges, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

import { Constants, EmailType } from '../constants';

@Component({
  selector: 'email-type-picker',
  templateUrl: './email-type-picker.component.html'
})
export class EmailTypePickerComponent implements OnInit {

  @Input()
  selectedTypes: any[];

  @Input()
  options: EmailTypePickerOptions;

  @Output('onChange')
  onChange: EventEmitter<Array<EmailType>> = new EventEmitter<Array<EmailType>>();

  // email type dropdown multiselect
  ddEmailTypes: any[] = [];
  emailTypeDDSettings: any = {
    enableCheckAll: false,
    groupBy: true,
    text: 'Select field',
    enableSearchFilter: false,
    badgeShowLimit: 5,
    maxHeight: 500
  };
  selectedDDTypes: any[] = [];

  constructor(private constants: Constants,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.options.standard.forEach(t => {
      let emailType = this.constants.emailTypes.find(type => { return type.typeName == t });
      this.ddEmailTypes.push({
        id: emailType.typeName,
        itemName: emailType.display,
        category: 'Standard Types'
      });
    });

    this.options.advanced.forEach(t => {
      let emailType = this.constants.emailTypes.find(type => { return type.typeName == t });
      this.ddEmailTypes.push({
        id: emailType.typeName,
        itemName: emailType.display,
        category: 'Advanced (not recommended)'
      });
    });

    this.initSelected();
  }

  initSelected() {
    this.selectedTypes.forEach(t => {
      let type = this.constants.emailTypes.find(et => { return et.typeName == t });
      this.selectedDDTypes.push({
        id: type.typeName,
        itemName: type.display
      });
    });
  }

  change() {
    // determine if at least one is selected
    let oneSelected: boolean = this.selectedDDTypes.length > 0;

    if (this.options.required && !oneSelected) {
      this.modalService.show(AlertDialogComponent, Object.assign({}, {
        initialState: {
          message: `At least one email type must be selected. We've reset to the default selection`,
          confirmBtn: 'Ok'
        }
      }));

      //select the default options if none are selected but at least one is required
      setTimeout(() => {
        this.setDefaults();
        this.initSelected();
        this.onChange.emit(this.selectedTypes);
      }, 50);
    }
    else {
      this.selectedTypes.length = 0; // clear the array without loosing any references to it
      this.selectedDDTypes.forEach(ddt => {
        this.selectedTypes.push(this.constants.emailTypes.find(et => { return et.typeName == ddt.id }).typeName);
      });
      this.onChange.emit(this.selectedTypes);
    }
  }

  private setDefaults() {
    this.selectedTypes.length = 0; // clear the array without loosing any references to it
    this.options.default.include.forEach(dt => {
      this.selectedTypes.push(this.constants.emailTypes.find(et => { return et.typeName == dt }).typeName);
    });
  }
}

export interface EmailTypePickerOptions {
  required: boolean;  // require at least one to be selected
  default: {
    include: string[],
    exclude: string[]
  };
  standard: string[];
  advanced: string[];
}



// WEBPACK FOOTER //
// ./client/app/global/email-type-picker/email-type-picker.component.ts